import { APIS } from 'scbk-certificates/constants/apiPaths';
import getDebtBalance from './kr/getDebtBalance.json';
import getDepositBalance from './kr/getDepositBalance.json';
import getFinancialTransact from './kr/getFinancialTransact.json';
import getPoint from './kr/getPoint.json';
import houseCapitalRepay from './kr/houseCapitalRepay.json';
import houseMortgageLoanRate from './kr/houseMortgageLoanRate.json';
import listAccount from './kr/listAccount.json';
import listDepositBalance from './kr/listDepositBalance.json';
import listFinancialIncome from './kr/listFinancialIncome.json';
import listFinancialTransact from './kr/listFinancialTransact.json';
import listPaymentAccount from './kr/listPaymentAccount.json';
import settingsCodeList from './kr/settingsCodeList.json';

export const MockConfig = {
    ['/utilities/settings/code/list']: () => settingsCodeList,
    [APIS.services.customer.inquiry.listDepositBalance]: () => listDepositBalance, //예금잔액증명서 발급내역
    [APIS.services.customer.inquiry.listFinancialTransact]: () => listFinancialTransact, //금융거래확인서 발급내역
    [APIS.services.customer.inquiry.getDepositBalance]: () => getDepositBalance, //예금잔액증명서 발급상세
    [APIS.services.customer.inquiry.getFinancialTransact]: () => getFinancialTransact, //금융거래확인서 발급상세
    [APIS.services.customer.inquiry.getDebtBalance]: () => getDebtBalance, //부채잔액증명서 발급상세
    [APIS.services.customer.issue.listAccount]: () => listAccount,
    [APIS.services.customer.issue.issueFinancialIncome]: () => listFinancialIncome,
    [APIS.services.customer.issue.issueHouseMortgageLoanRate]: () => houseMortgageLoanRate,
    [APIS.services.customer.issue.issueHouseCapitalRepay]: () => houseCapitalRepay,
    [APIS.services.customer.apply.listPaymentAccount]: () => listPaymentAccount,
    [APIS.services.customer.apply.getPoint]: () => getPoint,
};
